<template>
  <div>
    <el-tabs v-model="show">
      <el-tab-pane label="按关键词查" name="KEY_WORD">
        <key-word-search-component></key-word-search-component>
      </el-tab-pane>
      <el-tab-pane label="按关注项查" name="TABLE">
        <concerned-search-component></concerned-search-component>
      </el-tab-pane>
      <el-tab-pane label="按客户名称查询" name="CUSTOMER">
        <customer-search-component></customer-search-component>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ConcernedSearchComponent from "@/components/search/ConcernedSearchComponent";
import KeyWordSearchComponent from "@/components/search/KeyWordSearchComponent";
import CustomerSearchComponent from "@/components/search/CustomerSearchComponent";

export default {
  name: "SearchPage",
  components: {CustomerSearchComponent, KeyWordSearchComponent, ConcernedSearchComponent},
  data() {
    return {
      show: 'KEY_WORD'
    }
  }
}
</script>

<style scoped>

</style>
